export enum NewsType {
	Software	= 1,
	Osteopathy	= 2,
	Health		= 3
}